import { Divider } from "@mui/material";
import { ILearningObjectivesProps } from "../types/interfaces/ILearningObjectivesProps";
import ObjectivesInput from "./ObjectivesInput";
import ObjectivesStaticText from "./ObjectivesStaticText";

//This component is responsible for rendering the learning objectives. 
const LearningObjectives: React.FC<ILearningObjectivesProps> = ({ isReadOnly, objectives, onObjectivesChange }) =>  {
    //Function to handle objectives change.
    const handleObjectivesChange = (changedObjectives: string) => {
        onObjectivesChange(changedObjectives);
    };

    return (
        <>
            <ObjectivesStaticText />
            <ObjectivesInput isReadOnly={isReadOnly} objectives={objectives} onObjectivesChange={handleObjectivesChange} />
            <Divider sx={{mt:1, mb:5}}></Divider>
        </>
    );
}

export default LearningObjectives;